export const localesWithNoSocialLinks = ['en-US', 'en-CA', 'fr-CA'];

